// extracted by mini-css-extract-plugin
module.exports = {"panelContainer":"styles_panelContainer__3SWzs","slideInFromRight":"styles_slideInFromRight__R7NLq"};